"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _modal = _interopRequireDefault(require("webmotors-react-pj/modal"));
var _button = _interopRequireDefault(require("webmotors-react-pj/button"));
var _config = require("webmotors-react-pj/config");
var _utils = require("webmotors-react-pj/utils");
var _load = _interopRequireDefault(require("webmotors-react-pj/frame/load"));
var _search = _interopRequireDefault(require("webmotors-react-pj/frame/modal/store/search"));
var _selectState = _interopRequireDefault(require("webmotors-react-pj/frame/modal/store/select-state"));
var _list = _interopRequireDefault(require("webmotors-react-pj/frame/modal/store/list"));
var _style = _interopRequireDefault(require("webmotors-react-pj/frame/modal/store/style"));
var _lang = _interopRequireDefault(require("webmotors-react-pj/i18n/lang"));
var _img = _interopRequireDefault(require("webmotors-react-pj/img"));
var _style2 = require("./style");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = _ref => {
  let {
    onClose,
    onRedirect = false
  } = _ref;
  const [loaded, setLoaded] = (0, _react.useState)(false);
  const [success, setSuccess] = (0, _react.useState)(false);
  const [content, setContent] = (0, _react.useState)([]);
  const [filteredContent, setFilteredContent] = (0, _react.useState)(false);
  const [states, setStates] = (0, _react.useState)();
  const [selectedStore, setSelectedStore] = (0, _react.useState)({});
  const [title, setTitle] = (0, _react.useState)(_lang.default.pageStatus.load);
  (0, _react.useEffect)(() => {
    (0, _utils.Ajax)({
      url: "".concat(/estoque.webmotors/.test(window.location.host) ? '/api' : _config.ApiCockpit, "/group/store"),
      method: 'GET'
    }).then(e => {
      const {
        success: successStore,
        data
      } = e;
      if (successStore) {
        const dataFormat = data.map(item => ({
          title: item.estado,
          items: item.lojas
        }));
        const statesFormat = data.map(item => ({
          title: item.estado
        }));
        setSuccess(true);
        setTitle(_lang.default.storeGroup.title);
        setContent(dataFormat);
        setContent(dataFormat);
        setStates(statesFormat);
      } else {
        setSuccess(false);
        setTitle(_lang.default.header.errorList);
        setContent(data);
      }
      setLoaded(true);
    });
  }, []);
  const handleFilterByState = state => {
    if (!!state) {
      const tempContent = content.filter(item => item.title === state && item);
      setFilteredContent(tempContent);
    } else {
      setFilteredContent(false);
    }
  };
  const handleSearchByText = text => {
    if (!!text) {
      let tempContent = [];
      content.forEach(item => {
        const tempItems = item.items.filter(store => store.nomeFantasia.toLowerCase().includes(text.toLowerCase()) && store);
        if (tempItems.length > 0) tempContent.push({
          title: item.title,
          items: tempItems
        });
      });
      setFilteredContent(tempContent);
    } else {
      setFilteredContent(false);
    }
    ;
  };
  const handleSelectStore = () => {
    setLoaded(false);
    (0, _utils.getUserGroup)({
      id: (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.id) || 0,
      redirect: onRedirect,
      name: (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.name) || ''
    });
  };
  const renderContent = () => success ? _react.default.createElement(_style2.StyleContainer, null, _react.default.createElement(_img.default, {
    className: "modal__icon",
    src: "".concat(_config.UrlCockpit, "/assets/img/icons/pin-map-bold.svg")
  }), _react.default.createElement(_style2.StyleTitle, null, title), _react.default.createElement(_style2.StyleSubTitle, null, _lang.default.storeGroup.subtitle), _react.default.createElement(_selectState.default, {
    data: states,
    callback: handleFilterByState
  }), _react.default.createElement(_search.default, {
    onSearch: handleSearchByText
  }), _react.default.createElement(_style2.StyleSeparator, null), _react.default.createElement(_list.default, {
    data: filteredContent || content,
    setSelectedStore: setSelectedStore
  }), _react.default.createElement(_style2.StyleSeparator, {
    margin: '8px 0px 40px 0px'
  }), _react.default.createElement(_button.default, {
    type: "button",
    token: "primary",
    onClick: e => handleSelectStore()
  }, _lang.default.header.select)) : _react.default.createElement(_style.default, null, content);
  return _react.default.createElement(_modal.default, {
    size: 'medium',
    onClose: () => onClose()
  }, loaded ? renderContent() : _react.default.createElement(_load.default, null));
};
exports.default = _default;